import { sanitizeHtml } from "./sanitizeHtml";

const collapseWhitespace = (value = "") => String(value || "").replace(/\s+/g, " ").trim();

export const htmlToPlainText = (value = "") => {
  const safeHtml = sanitizeHtml(value || "");
  if (typeof window !== "undefined" && typeof DOMParser !== "undefined") {
    try {
      const doc = new DOMParser().parseFromString(String(safeHtml || ""), "text/html");
      return collapseWhitespace(doc.body?.textContent || "");
    } catch {
      // fall through to regex fallback
    }
  }
  return collapseWhitespace(
    String(safeHtml || "")
      .replace(/<[^>]+>/g, " ")
      .replace(/&nbsp;/gi, " "),
  );
};

export const buildHtmlPreviewText = (value = "", maxLength = 160) => {
  const text = htmlToPlainText(value);
  const limit = Number(maxLength || 0);
  if (!text) return "";
  if (!Number.isFinite(limit) || limit <= 0 || text.length <= limit) return text;
  return `${text.slice(0, Math.max(1, limit - 3)).trimEnd()}...`;
};
